import React from 'react';
import { Outlet, Link } from 'react-router-dom';

import PageTitleNew from 'components/ui/PageTitleNew';
import routes from 'app/routes';

import Table from './Table';

export default function Index() {
  return (

    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Reports" />

      <div className="ibox-content mt20">
        <div className="text-right">
          <Link
            to={routes.admin.report_templates.new}
            className="btn btn-primary"
          >
            Add Report
          </Link>
        </div>
        <Table />
        <Outlet />
      </div>
    </div>
  );
}
